import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { CashTrackingStartTrackingPage } from 'src/app/modals/cash-tracking-start-tracking/cash-tracking-start-tracking.page';

const routes: Routes = [
  {
    path: '',
    component: CashTrackingStartTrackingPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [CashTrackingStartTrackingPage]
})
export class CashTrackingStartTrackingPageModule {}
